import React, {FunctionComponent} from "react";
import {Link} from "gatsby";
import {Divider} from "../../divider";

const styles = require('./blogLayout.component.scss');

//Blog layout component to override wordpress CSS styling

interface Props {
    hideBackButton?: boolean;
    mobileNoPadding?: boolean;
    noStats?: boolean;
    imageUrl: string;
    brandImageUrl?: string;
    title: string;
    description: string;
    date?: string;
    hideDivider?: boolean;
    hideBlogDefaultData?: boolean;
    wideWidth?: boolean;
}

export const BlogLayout: FunctionComponent<Props> = props => {
    const {hideBackButton, mobileNoPadding, noStats, imageUrl, brandImageUrl, title, description, date, hideDivider, hideBlogDefaultData, wideWidth, children} = props;
    return (
    <>
        {!hideBackButton &&
            <div className={styles.backLinkCont}>
                <div className={styles.backLink}>
                    <Link to={"/"}>
                        <i className={'fa fa-arrow-left'}></i>Go Back
                    </Link>
                </div>
            </div>
        }
        <div className={`${styles.blogContainer} ${mobileNoPadding ? styles.blogNoPadding : ''} ${noStats ? styles.noMarginBottom : ''}
         ${wideWidth ? styles.wideWidth : ''}`}>
            {!hideBlogDefaultData && <div className={styles.postImage}>
                <img src={imageUrl}/>
            </div>}
            <div className={`textContainer ${wideWidth ? styles.wideWidth : ''}`}>
                {!hideBlogDefaultData && <>
                    {brandImageUrl && <div className={styles.brandImage}>
                        {brandImageUrl && <img src={brandImageUrl} alt={''}/>}
                    </div>}
                    {/*special class for smaller blog post width*/}
                    <h1
                        dangerouslySetInnerHTML={{__html: title}}
                    />
                    {description && <div className={styles.excerpt} dangerouslySetInnerHTML={{__html: description}}/>}
                    {date && <div className={styles.info}>{date}</div>}
                    {!hideDivider && <Divider direction={"horizontal"}/>}
                </>}
                {children}
            </div>
        </div>
    </>
  )
};
